import { ref, get, update } from "firebase/database";
import { database } from "../firebase";

/**
 * Updates the current user's name in all of their cases in Firebase, skipping demo cases.
 * @param {object} user - The current user object (must have `id` and `cases` array)
 * @param {string} newUserName - The new name to set for this user in all their cases
 */
const updateUserSpecificCases = async (user, newUserName) => {
  try {
    if (!user?.id || !Array.isArray(user.cases) || user.cases.length === 0)
      return;

    const userId = user.id;
    const updates = {};
    const failedCases = []; // Track failed caseIds

    for (const caseId of user.cases) {
      try {
        const caseRef = ref(database, `cases/${caseId}`);
        const snapshot = await get(caseRef);

        if (snapshot.exists()) {
          const caseData = snapshot.val();

          // Skip if this is a demo case
          if (caseData.isDemo) {
            continue;
          }

          // Only proceed if users map exists and contains this user
          if (caseData.users && caseData.users[userId]) {
            if (caseData.users[userId].name !== newUserName) {
              const updatedUsers = {
                ...caseData.users,
                [userId]: {
                  ...caseData.users[userId],
                  name: newUserName,
                },
              };
              updates[`cases/${caseId}/users`] = updatedUsers;
            }
          }
        }
      } catch (err) {
        console.error(`Failed to fetch or process caseId: ${caseId}`, err);
        failedCases.push(caseId);
      }
    }

    if (Object.keys(updates).length > 0) {
      try {
        await update(ref(database), updates);
      } catch (err) {
        // If the batch update fails, print all relevant caseIds
        console.error(
          "Failed to update cases in batch for the following caseIds:",
          Object.keys(updates).map((path) => path.split("/")[1])
        );
        console.error(err);
      }
    }

    if (failedCases.length > 0) {
      console.warn("Cases that gave error during fetch/process:", failedCases);
    }
  } catch (error) {
    console.error("Failed to update user name in cases (general):", error);
    // Do not throw error, just log it
  }
};

export { updateUserSpecificCases };
